import { render, staticRenderFns } from "./AddKamus.vue?vue&type=template&id=d301017a&"
import script from "./AddKamus.vue?vue&type=script&lang=js&"
export * from "./AddKamus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports